import BunnyVideo, { type BunnyVideoProps } from "@common/controls/Video/Bunny/component";
import HtmlVideo from "@common/controls/Video/HTML/component";
import VideoJs from "@common/controls/Video/VideoJs/component";
import VimeoVideo from "@common/controls/Video/Vimeo/component";
import WistiaVideo from "@common/controls/Video/Wistia/component";
import YouTubeVideo from "@common/controls/Video/YouTube/component";
import Video from "@common/controls/Video/component";

import "./style.less";

export { BunnyVideo, HtmlVideo, VideoJs, VimeoVideo, WistiaVideo, YouTubeVideo, type BunnyVideoProps };
export default Video;
